import useSWR from 'swr';
import { axiosInstance } from './api';

/** Автоотправка отчёта точки без валидатора (Алексей 27.10 #3005) — только суперюзер.
 *  BE plugins/periodic_reports/api/views.py report_auto_send. */
export interface ReportAutoSendDto {
  enabled: boolean;
  send_time: string; // "HH:MM", местное время точки
  changed_by: string | null;
  changed_at: string | null;
  /** Замок: на полках точки красная отметка по отменам — включить нельзя. */
  locked: boolean;
  lock_reasons: string[];
  rule: string;
}

export const reportAutoSendKey = (zoneId: string) => ['report-auto-send', zoneId] as const;

export function useReportAutoSend(zoneId: string | null, enabled = true) {
  return useSWR(zoneId && enabled ? reportAutoSendKey(zoneId) : null,
    () => axiosInstance.get<ReportAutoSendDto>(`/periodic_reports/auto-send/${zoneId}/`).then((r) => r.data),
    { revalidateOnFocus: false });
}

export const putReportAutoSend = (zoneId: string, body: Partial<Pick<ReportAutoSendDto, 'enabled' | 'send_time'>>) =>
  axiosInstance.put<ReportAutoSendDto>(`/periodic_reports/auto-send/${zoneId}/`, body);
